import React from 'react';

/*
 * "Everyone in these photos is OK with it."
 *
 * Club photos end up on posters on the clubhouse screen, in newsletters
 * emailed to the whole club, and on the club's public page. The terms of
 * use make the club responsible for having permission — and a parent's or
 * guardian's for anyone under 18 — but nothing on the screen said so at the
 * moment it mattered, which is when somebody is choosing what to upload.
 *
 * So the upload buttons wait for a tick. Once per browser session, not per
 * photo: the point is to make the question asked, not to make an admin
 * click it forty times on the day they set up the gallery.
 */

const KEY = 'gs-photo-permission';

export function usePhotoPermission() {
  const [ok, setOk] = React.useState(() => {
    try { return sessionStorage.getItem(KEY) === 'yes'; } catch (e) { return false; }
  });
  const set = (value) => {
    setOk(value);
    try { if (value) sessionStorage.setItem(KEY, 'yes'); else sessionStorage.removeItem(KEY); } catch (e) { /* private mode */ }
  };
  return [ok, set];
}

function PhotoPermission({ ok, onChange, id = 'photo-permission' }) {
  return (
    <label className="photo-permission" htmlFor={id}>
      <input id={id} type="checkbox" className="gs-check" checked={ok}
        onChange={e => onChange(e.target.checked)} />
      <span>
        Everyone in these photos is happy for them to be used — and a parent or guardian has
        agreed for anyone under 18.{' '}
        <a href="/terms.html#clubs" target="_blank" rel="noopener">Why we ask</a>
      </span>
    </label>
  );
}

export default PhotoPermission;
